import { types, Instance } from 'mobx-state-tree';
import { withRunInAction } from 'utils/withRunInAction';
import { AnnoUiFrameItem, AnnoUiItem, AnnoUiLabelItem, AnnoUiRegionItem } from 'utils/cfUiItems/annotations';

export const AnnotationMST = types
  .compose(
    withRunInAction(),
    types.model({
      created_at: types.optional(types.string, ''),
      data: types.frozen<CF.API.Annotations.Annotation['data']>(),
      embed_model_version_id: types.frozen<string | undefined>(),
      id: types.string,
      input_id: types.string,
      task_id: types.maybe(types.string),
      modified_at: types.optional(types.string, ''),
      status: types.frozen<CF.API.Status | undefined>(),
      trusted: types.frozen<boolean | undefined>(),
      isSuggestion: types.maybe(types.boolean),
      // When user selects a concept from the concept selector, it is temporarily added to the annotation list
      isTemporary: types.maybe(types.boolean),
      internalId: types.maybe(types.string),
      worker: types.frozen<CF.API.Worker | undefined>(),
    }),
  )
  .named('AnnotationMST')
  .volatile(() => ({
    isHidden: false,
  }))
  .actions((self) => ({
    toggleVisibility: () => {
      self.isHidden = !self.isHidden;
    },
  }));

export type TIAnnotationMST = Instance<typeof AnnotationMST>;

export type AnnotationMSTByType = {
  bbox: AnnoUiRegionItem<TIAnnotationMST>[];
  polygon: AnnoUiRegionItem<TIAnnotationMST>[];
  imagemask: AnnoUiRegionItem<TIAnnotationMST>[];
  unsupported: AnnoUiItem<TIAnnotationMST>[];
  concept: AnnoUiLabelItem<TIAnnotationMST>[];
  frame: AnnoUiFrameItem<TIAnnotationMST>[];
};
